import * as IRemirror from '../types/rich-text';
import type { QuickChartData } from '../types/widget-grid';

export function setInsightsDataUtil(chartData: QuickChartData): IRemirror.RootNode | null {
  if (chartData.insights) {
    try {
      return JSON.parse(chartData.insights) as IRemirror.RootNode;
    } catch {
      // If insights is a plain string, create a simple document structure
      return {
        type: IRemirror.NodeType.Doc,
        content: [
          {
            type: IRemirror.NodeType.Paragraph,
            content: [{ type: IRemirror.NodeType.Text, text: chartData.insights }],
          },
        ],
      };
    }
  }
  return null;
}